// extracted by mini-css-extract-plugin
export default {"edit":"Ban_edit__wynxk","desc":"Ban_desc__1RnqX","btns":"Ban_btns__P70K3"};